/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteClientBillToInput = {
    clientBillToId: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type DeleteClientBillToMutationVariables = {
    input: DeleteClientBillToInput;
};
export type DeleteClientBillToMutationResponse = {
    readonly deleteClientBillTo: {
        readonly deletedClientBillToId: string | null;
    } | null;
};
export type DeleteClientBillToMutation = {
    readonly response: DeleteClientBillToMutationResponse;
    readonly variables: DeleteClientBillToMutationVariables;
};



/*
mutation DeleteClientBillToMutation(
  $input: DeleteClientBillToInput!
) {
  deleteClientBillTo(input: $input) {
    deletedClientBillToId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteClientBillToInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteClientBillToPayload",
    "kind": "LinkedField",
    "name": "deleteClientBillTo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedClientBillToId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteClientBillToMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteClientBillToMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DeleteClientBillToMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteClientBillToMutation(\n  $input: DeleteClientBillToInput!\n) {\n  deleteClientBillTo(input: $input) {\n    deletedClientBillToId\n  }\n}\n"
  }
};
})();
(node as any).hash = '71450eda6154dbd804026593606ab845';
export default node;
